// @ngInject
function VariantGroupsApiService(ResourcesService) {

    var endpoint = 'variantgroups';

    return {
        getVariantBriefs: ResourcesService.apiFactory.get(endpoint + '/variantbriefs'),
        getVariantDetails: ResourcesService.apiFactory.get(endpoint + '/variantdetails'),
        getVariantGroupBriefs: getVariantGroupBriefs,
        getVariantGroup: ResourcesService.apiFactory.get(endpoint),
        saveVariantGroup: ResourcesService.apiFactory.save(endpoint, 'VariantGroup')
    };

    function getVariantGroupBriefs(page, filter, pageSize) {
        var params = {};

        if (page && page > 1) {
            params.page = page - 1;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        if (!_.isEmpty(filter)) {
            params.searchTerm = filter;
        }

        var args = { params: params };

        return ResourcesService.apiFactory.get(endpoint + '/briefs')(args);
    }
}

angular.module('variantgroups.api', [])
  .factory('VariantGroupsApiService', VariantGroupsApiService);

